import type { ShipstarConfig } from "./types";

export function formatDateRange(start: string, end: string): string {
  try {
    const s = new Date(start + "T00:00:00");
    const e = new Date(end + "T00:00:00");
    const opts: Intl.DateTimeFormatOptions = { month: "short", day: "numeric" };
    const yearOpts: Intl.DateTimeFormatOptions = { ...opts, year: "numeric" };

    if (s.getFullYear() !== e.getFullYear()) {
      return `${s.toLocaleDateString("en-US", yearOpts)} \u2014 ${e.toLocaleDateString("en-US", yearOpts)}`;
    }
    return `${s.toLocaleDateString("en-US", opts)} \u2014 ${e.toLocaleDateString("en-US", yearOpts)}`;
  } catch {
    return `${start} \u2014 ${end}`;
  }
}

const ESCAPE_MAP: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "`": "&#96;",
  "=": "&#61;",
  "/": "&#47;",
};

const ESCAPE_RE = /[&<>"'`=\/]/g;

export function escapeHtml(str: string): string {
  if (!str) return "";
  return String(str).replace(ESCAPE_RE, (ch) => ESCAPE_MAP[ch] || ch);
}

/**
 * Escape for an HTML attribute value (URLs). Unlike escapeHtml it leaves
 * "/" and "=" alone so an href stays readable; quotes and angle brackets
 * are still neutralised.
 */
export function escapeAttr(str: string): string {
  if (!str) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function debugLog(config: ShipstarConfig, ...args: unknown[]): void {
  if (config.debug) {
    console.log("[Shipstar]", ...args);
  }
}
